// extracted by mini-css-extract-plugin
module.exports = {"prices":"_24XLO","outOfStock":"xyTge","mobile":"_3H_e9","priceBeforeDiscount":"_3Mr0A","priceFrom":"_3RJlc","priceToPay":"_2-l9W","basePrice":"_37YSe","priceBreakdown":"BGosv"};